import API_ROUTES from "../constants/api";
import HttpUtil from "../http-handler/http-util";

export default class EmailAuditService {
  static getEmailAuditLogs(
    pageNumber = 0,
    pageSize = 10,
    companyId = "",
    searchKey = "",
    sort = "createdDate,desc",
    emailType = "",
    status = ""
  ) {
    return HttpUtil.get(
      API_ROUTES.EMAIL_AUDIT.LIST.replace("<pageNumber>", pageNumber)
        .replace("<pageSize>", pageSize)
        .replace("<sort>", sort)
        .replace(companyId ? "<companyId>" : "&companyId=<companyId>", companyId ?? '')
        .replace(searchKey ? "<key>" : "&key=<key>", encodeURIComponent(searchKey ?? ""))
        .replace(emailType ? "<emailType>" : "&emailType=<emailType>", emailType ?? "")
        .replace(status ? "<status>" : "&status=<status>", status ?? "")
    );
  }
}
